import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SchoolSharpIcon from "@mui/icons-material/SchoolSharp";
import Link from "next/link";
import styles from "./ClosingHero.module.css";
import { Button, Typography, useMediaQuery } from "@mui/material";
import hero from "../../../assets/prtp/closingHero.png";
import Image from "next/image";
import SignUpModal from "../../ModalContent/SignUpModal/SignUpModal";

const ClosingHero = ({ isLoggedIn }) => {
  //sign up modal
  const [openSingUp, setOpenSignUp] = React.useState(false);
  const handleSignUpClose = () => {
    setOpenSignUp(false);
  };

  const handleSignUpOpen = () => {
    setOpenSignUp(true);
  };

  const matches = useMediaQuery("(max-width:768px)");
  return (
    <Container>
      <Row className="justify-content-center align-items-center py-5">
        <Col md={6} xs={12}>
          <Image src={hero} alt="man with research" priority />
        </Col>
        <Col md={6} xs={12} className={`${styles.right_col}`}>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: matches ? "32px" : "48px",
              fontWeight: "600",
              lineHeight: "1.2em",
              marginBottom: "32px",
            }}
            component="div"
          >
            Get started <br /> and grow up being a researcher
          </Typography>

          {isLoggedIn ? (
            <Link href="/course/payment/4">
              <Button
                className={`${styles.enrollBtn} px-5 p-2`}
                variant="contained"
                startIcon={<SchoolSharpIcon className={styles.icon} />}
              >
                Enroll Now
              </Button>
            </Link>
          ) : (
            <Button
              onClick={() => setOpenSignUp(true)}
              className={`${styles.enrollBtn} px-5 p-2`}
              variant="contained"
              startIcon={<SchoolSharpIcon />}
            >
              Enroll Now
            </Button>
          )}
        </Col>
      </Row>
      <>
        <SignUpModal
          open={openSingUp}
          handleClose={handleSignUpClose}
          handleOpen={handleSignUpOpen}
          courseID="4"
        />
      </>
    </Container>
  );
};

export default ClosingHero;

{
  /* <Button
onClick={() => setOpenSignUp(true)}
className={`${styles.enrollBtn} px-3 p-2`}
variant="contained"
startIcon={<LocalMallIcon />}
>
Enroll Now
</Button> */
}
